import { IModel, Model } from '@common/models/Model';

export interface IReminderSourceModel extends IModel {
  reminderSourceId: number;
  name: string;
}

export class ReminderSourceModel extends Model implements IReminderSourceModel {
  reminderSourceId: number;
  name: string;

  constructor(params?: Partial<IReminderSourceModel>) {
    super(params);

    this.reminderSourceId = _.defaultTo(params?.reminderSourceId, 0);
    this.name = _.defaultTo(params?.name, '');
  }
}
